import { render } from "./Create-new-gift-card.vue?vue&type=template&id=3a9725ec"
import script from "./Create-new-gift-card.vue?vue&type=script&lang=js"
export * from "./Create-new-gift-card.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__